import type { ReactNode } from 'react';
import {
  MessageSquare,
  Inbox,
  UserPlus,
  PenLine,
  Clock,
  Plug,
  Users,
  Newspaper,
  Mail,
  BookText,
  ShieldCheck,
  FileText,
} from 'lucide-react';
import { docsUrl } from '@/lib/links';

/**
 * Header navigation data. Labels and descriptions are NOT stored here — they
 * live in i18n under `header.menu.*` and are looked up by `key`, so Arabic copy
 * stays hand-written and RTL-correct. Each entry only carries its destination
 * and icon.
 */
export type NavLink = {
  /** i18n key under the relevant `header.menu.*` group. */
  key: string;
  href: string;
  icon: ReactNode;
  /** External links open in a new tab and use a plain anchor (no locale prefix). */
  external?: boolean;
};

/** Product mega-menu — two labelled groups, deep-linking into the two
 *  product pages (Vercel-style: sparse home, detail on product pages). */
export const productGroups: { key: string; items: NavLink[] }[] = [
  {
    key: 'create',
    items: [
      { key: 'studio', href: '/products/create#studio', icon: <PenLine /> },
      { key: 'publish', href: '/products/create#publish', icon: <Clock /> },
      { key: 'voices', href: '/products/create#voices', icon: <MessageSquare /> },
    ],
  },
  {
    key: 'sell',
    items: [
      { key: 'inbox', href: '/products/sell#inbox', icon: <Inbox /> },
      { key: 'chat', href: '/products/sell#chat', icon: <UserPlus /> },
      { key: 'checkout', href: '/products/sell#checkout', icon: <Plug /> },
    ],
  },
];

/** Flat list (mobile menu + anywhere that wants all six). */
export const productLinks: NavLink[] = productGroups.flatMap((g) => g.items);

/** Company mega-menu — primary column (rich rows with descriptions). */
export const companyLinks: NavLink[] = [
  { key: 'about', href: '/about', icon: <Users /> },
  { key: 'blog', href: '/blog', icon: <Newspaper /> },
  { key: 'contact', href: '/contact', icon: <Mail /> },
];

/** Company mega-menu — secondary column (compact icon + label list). */
export const companyLinks2: NavLink[] = [
  { key: 'docs', href: docsUrl, icon: <BookText />, external: true },
  { key: 'privacy', href: '/privacy', icon: <ShieldCheck /> },
  { key: 'terms', href: '/terms', icon: <FileText /> },
];
